import React from "react";
import Title from "../title";
import styled from "styled-components";
import rwd from '../../assets/rwd.png';
import login from '../../assets/login.png';
import {BorderGradient, Button, TextGradient} from "../../styles/globalStyles";
import {device} from "../../styles/breakpoints";


const Wrapper = styled.div`
  width: 100%;
  display: grid;
  margin-top: 10vh;
  gap: 40px;
  grid-template-columns: 1fr;
  align-items: center;
  @media ${device.tablet} {
    grid-template-columns: 1fr 1fr;

  }
`;


const Image = styled.div`
  width: 100%;
  height: 350px;
  background-image: url(${({img}) => img});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  align-self: center;
`;

const StyledBorderGradient = styled(BorderGradient)`
  width: 100%;
  height: 300px;
  border-radius: 30px;
  margin-top: 10vh;
  border-width: 5px;
  grid-column: 1/-1;
  justify-self: center;
  @media ${device.desktop} {
    width: 50%;
  }
`;

const CardGradient = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 30px;
  background-image: linear-gradient(to right, rgba(0, 240, 255, 15%), rgba(255, 0, 122, 15%));
  padding: 5vh 5vw;
  display: flex;
  flex-direction: column;


  &:last-child {
    padding: 10px;
    align-self: flex-end;
    justify-content: space-between;
  }
`;
const H3 = styled(TextGradient)`
  margin: 0;
  font-weight: bold;
  width: 70%;
  @media ${device.tablet} {
    font-size: 25px;
  }
`;

const Paragraph = styled.p`
  font-size: 10px;
  text-align: justify;
  @media ${device.tablet} {
    font-size: 10px;
  }
`;


const ImagesSection = () => (
  <Wrapper>
    <Title bl h1='Custom Interface' h3='What is' isButtonShow>Lorem ipsum dolor sit amet, consectetur adipiscing
      elit.
      Vitae quam sit
      scelerisque enim in sed diam nec, blandit. Amet tellus massa sed iaculis. Mauris, curabitur scelerisque sagittis
      posuere mollis. In dolor neque et vitae lectus vulputate pellentesque luctus.</Title>

    <Image img={rwd}/>
    <Image img={login}/>
    <Title bl h1='Website with Ai' h3='You can maintain your' isButtonShow>Lorem ipsum dolor sit amet, consectetur
      adipiscing elit.
      Vitae quam sit
      scelerisque enim in sed diam nec, blandit. Amet tellus massa sed iaculis. Mauris, curabitur scelerisque sagittis
      posuere mollis. In dolor neque et vitae lectus vulputate pellentesque luctus.</Title>

    <StyledBorderGradient>
      <CardGradient>
        <H3 as='h3'>Increase your sales by analyzing your collected data!</H3>
        <Paragraph>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vitae quam sit scelerisque enim in sed diam
          nec,
          blandit. Amet tellus massa sed iaculis. Mauris, curabitur scelerisque sagittis posuere mollis. In dolor neque
          et vitae lectus vulputate pellentesque luctus.</Paragraph>
        <Button as='button'>Learn More...</Button>
      </CardGradient>
    </StyledBorderGradient>
  </Wrapper>
);
export default ImagesSection;
